import {
  CommonMFE,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import React, { useEffect, useState } from "react";
import {
  CartIcon,
  CenterContent,
  CenterContentContainer,
  CenterTopContent,
  ContainerDiv,
  Cta,
  CtaWrapper,
  DropdownContainer,
  LeftContent,
  LoginHome,
  Logo,
  LogoWrapper,
  MainMenu,
  MenuDropdown,
  MenuGridContainer,
  MenuIcon,
  MenuIconWrapper,
  MenuLink,
  MenuTitle,
  MenuTitleContainer,
  RightContent,
  RightTopContent,
  SubMenuLink,
  SubMenuTitle,
} from "./LowerHeaderDesktop.style";
import { stringToHexColor } from "../../App.mock";
import { Helpers } from "@tpd-web-common-libs/nodejs-library";
import classNames from "classnames";

type TLowerHeaderDesktopProps = {
  id: string;
  navigationMenu: any;
  menuLivello1: any;
  __host__: any;
  isEditMode: boolean;
  configHeader: any;
  logoPath: string;
  tipo?: string;
  showHideModal: () => void;
  config: any;
};

const mainColor = "main-color";

import ENV_CONFIG from "../../../../../../../config/envConfig/esm";
import { LINK } from "../LowerHeader";
import CasellaRicercaHeader from "../casella-ricerca-header/CasellaRicercaHeader";
import Login from "../../login/Login";

export const LINK_PREVENTIVATORE = {
  "/tpdweb/mobilita/assicurazione-auto": "/preventivatore-auto",
  "/tpdweb/mobilita/assicurazione-moto": "/preventivatore-moto",
  "/myportal/tpdweb/mobilita/assicurazione-auto": "/myportal/preventivatore-auto",
  "/myportal/tpdweb/mobilita/assicurazione-moto": "/myportal/preventivatore-moto",
}

const LowerHeaderDesktop = (props: TLowerHeaderDesktopProps) => {
  const {
    __host__,
    isEditMode,
    navigationMenu,
    menuLivello1,
    configHeader,
    logoPath,
    id: containerID,
    tipo,
    showHideModal: showModal,
    config,
  } = props;

  const {
    pageProperties: { isBusinessChild },
  } = __host__;

  const prodottoUnicoActive = ENV_CONFIG.PRODOTTO_UNICO_ACTIVE === "on";

  const isHCLAuthoringPage = Helpers.PageHelper.isHCLAuthoringPage();

  const rootPath = Helpers.EnvironmentHelper.isClientSide() ?
    (isHCLAuthoringPage ? window.location.pathname.split("/")[2] :
      window.location.pathname.split("/")[1])
    : "";

  const storeCartAndRedirect = async () => {
    try {
      await Helpers.SessionHelper.setData("pu_data_props", {
        showCarrello: true,
      });
      Helpers.RouterHelper.goTo("/prodotto-unico");
    } catch (error) {
      console.error("Failed to store cart", error);
    }
  };

  //TODO: rebranding 2025, rerendering
  const [isClient, setIsClient] = useState(false)
 
  useEffect(() => {
    setIsClient(true)
  }, [])

  const RebrandingLogoSwitch = () => { 
    return Helpers.BrandNameHelper.brand() === Helpers.EBrand.UNIPOL ?
    <Logo src='/NextAssets/images/logo_unipol.svg' alt={`${Helpers.BrandNameHelper.brandName()} Logo`}/> :
    <Logo src='/NextAssets/images/logo_unipolsai.png' alt={`${Helpers.BrandNameHelper.brandName()} Logo`}/>
  }

  const getTitleCTA = (url: string) => {
    if (url.includes("trova-agenzie")) {
      return "Trova agenzia"
    } else if (url.includes("servizio-clienti")) {
      return "Servizio clienti"
    } else {
      return ""
    }
  }

  //END TODO

  return (
    <ContainerDiv>
      <LeftContent>
        <LogoWrapper
          href={
            rootPath === "aziende" ?
              (isHCLAuthoringPage ? `/tpdweb/aziende` : LINK.AZIENDE) :
              (isHCLAuthoringPage ? `/tpdweb/homepage` : LINK.HOMEPAGE)
          }
          data-disabled={isEditMode}
          __deps__={React}
        >
        {/* {//TODO: logica per server side rebranding 2025, rerendering da eliminare a valle del rebranding } */
          isClient || !isClient ? 
          <RebrandingLogoSwitch></RebrandingLogoSwitch>
          : 
          <RebrandingLogoSwitch></RebrandingLogoSwitch>
        }

        </LogoWrapper>
      </LeftContent>
      <CenterContent>
        <CenterContentContainer>
          <CenterTopContent>
            {configHeader.search_bar && (
              <CasellaRicercaHeader
                __host__={__host__}
                id={CommonMFE.generateID(
                  containerID,
                  `${MFE_NAMES.tpdHeader}-${MFE_NAMES.tpdCasellaRicercaHeader}-desktop`
                )}
                isEditMode={isEditMode}
                config={config.tpdCasellaRicercaHeader}></CasellaRicercaHeader>
            )}
          </CenterTopContent>
          {configHeader.navigation_menu && (
            <MainMenu>
              {navigationMenu.map((menuLink: any, index) => (
                <DropdownContainer
                  key={CommonMFE.generateID(
                    menuLink.id,
                    "DropdownContainer-",
                    index
                  )}
                >
                  <MenuLink
                    color={stringToHexColor(menuLink.colorClassDesktop)}
                    href={menuLink.url}
                    data-disabled={isEditMode}
                    __deps__={React}
                    title={menuLink.name}
                    className={classNames(
                      {
                        selectedLink:
                          Helpers.UrlHelper.isHostUrlEqualToPageUrl(
                            __host__.url,
                            menuLink.url
                          ) && !isBusinessChild,
                      },
                      {
                        "main-theme":
                          Helpers.UrlHelper.isHostUrlEqualToPageUrl(
                            __host__.url,
                            menuLink.url
                          ) && isBusinessChild,
                      },
                      {
                        "hover-main-theme": isBusinessChild,
                      }
                    )}
                  >
                    {menuLink.name}
                  </MenuLink>
                  <MenuDropdown
                    color={
                      isBusinessChild
                        ? stringToHexColor(mainColor)
                        : stringToHexColor(menuLink.colorClassDesktop)
                    }
                  >
                    <MenuTitleContainer
                      className={classNames({
                        "main-theme": isBusinessChild,
                      })}
                      color={menuLink.color}
                    >
                      <MenuIconWrapper
                        className={classNames(menuLink.iconBackground, {
                          "main-theme": isBusinessChild,
                        })}
                        color={
                          !isBusinessChild
                            ? stringToHexColor(menuLink.colorClassDesktop)
                            : "transparent"
                        }
                      >
                        <MenuIcon className={menuLink.icon} />
                      </MenuIconWrapper>
                      <MenuTitle
                        color={stringToHexColor(menuLink.colorClassDesktop)}
                        href={menuLink.url}
                        data-disabled={isEditMode}
                        __deps__={React}
                        title={menuLink.name}
                        className={classNames({
                          "main-theme": isBusinessChild,
                        })}
                      >
                        {menuLink.name}
                      </MenuTitle>
                    </MenuTitleContainer>
                    <MenuGridContainer
                      className={classNames({
                        "main-theme": menuLink.subMenuBusinessV2,
                      })}
                    >
                      {menuLink.subMenu &&
                        menuLink.subMenu.map((gridItem: any, index) => (
                          <div
                            key={CommonMFE.generateID(
                              index,
                              "menuGridContainer"
                            )}
                          >
                            <SubMenuTitle
                              className={classNames(
                                { "main-theme": menuLink.subMenuBusinessV2 },
                                {
                                  underline:
                                    isBusinessChild &&
                                    !menuLink.subMenuBusinessV2,
                                }
                              )}
                              color={stringToHexColor(gridItem.dataCategory)}
                              href={LINK_PREVENTIVATORE[gridItem.url] ?? gridItem.url}
                              data-disabled={isEditMode}
                              __deps__={React}
                              title={gridItem.name}
                            >
                              {gridItem.name}
                            </SubMenuTitle>
                            {gridItem.subMenu &&
                              gridItem.subMenu.map(
                                (subMenulink: any, index) =>
                                  !menuLink.subMenuBusinessV2 && (
                                    <SubMenuLink
                                      key={CommonMFE.generateID(
                                        subMenulink.id,
                                        "submenuLink-",
                                        index
                                      )}
                                      href={subMenulink.url}
                                      data-disabled={isEditMode}
                                      __deps__={React}
                                      title={subMenulink.name}
                                    >
                                      {subMenulink.name}
                                    </SubMenuLink>
                                  )
                              )}
                          </div>
                        ))}
                    </MenuGridContainer>
                  </MenuDropdown>
                </DropdownContainer>
              ))}
            </MainMenu>
          )}
        </CenterContentContainer>
      </CenterContent>
      <RightContent>
        <RightTopContent />
        <CtaWrapper>
          {prodottoUnicoActive && (
            /* CARRELLO PRODOTTO UNICO */
            <Cta
              __deps__={React}
              onClick={tipo === "PF" ? storeCartAndRedirect : () => showModal()}
            >
              <CartIcon />
            </Cta>
          )}
          {configHeader.account_menu && (
            <>
              {menuLivello1.map((menuData) => (
                <Cta
                  key={menuData.id}
                  href={menuData.url}
                  data-disabled={isEditMode}
                  aria-label={Helpers.RouterHelper.normalizeHref(menuData.url)
                    .replace("-", " ")
                    .replace("/", "")}
                  __deps__={React}
                  title={getTitleCTA(menuData.url)}
                >
                  <i className={menuData.icon} />
                </Cta>
              ))}
              <LoginHome>
                <Login
                  __host__={__host__}
                  id={CommonMFE.generateID(
                    containerID,
                    `${MFE_NAMES.tpdHeader}-${MFE_NAMES.tpdLoginHeaderContainer}`
                  )}
                  isEditMode={isEditMode}
                  isLogoutOnly={config.tpdLoginHeaderNewArc.isLogoutOnly}
                  config={!config ? {} : config.tpdLoginHeaderNewArc}></Login>
              </LoginHome>
            </>
          )}
        </CtaWrapper>
      </RightContent>
    </ContainerDiv>
  );
};

export default LowerHeaderDesktop;
